import type { SchemaDisplayMetadata } from '@reach/shared-types/schema-mappings';
import { Shapes } from 'lucide-react';
import type { FC } from 'react';
import styles from './SchemaIcon.module.css';
import { resolveSchemaIcon } from './schema-icon-catalog';

interface SchemaIconProps {
  displayMetadata?: SchemaDisplayMetadata | null;
  /** Pixel size of the glyph. Defaults to a header-sized 24px. */
  size?: number;
  className?: string;
}

export const SchemaIcon: FC<SchemaIconProps> = ({ displayMetadata, size = 24, className }) => {
  const iconName = displayMetadata?.icon?.value;
  const color = displayMetadata?.color;
  const ResolvedGlyph = iconName ? resolveSchemaIcon(iconName) : null;
  const Glyph = ResolvedGlyph ?? Shapes;
  const glyphClass = ResolvedGlyph ? className : `${styles.placeholder} ${className ?? ''}`;

  return <Glyph size={size} style={color ? { color } : undefined} className={glyphClass} aria-hidden />;
};
